

export const system = [
    {
        path: '/system',
        name: '系统管理',
        redirect: 'system/site-settings',
        component: () => import("@/views/layout/index.vue"),
        children: [
            {
                path: 'site-settings',
                component: () => import("@/views/admin/system/site-settings/index.vue"),
                name: '站点设置',
                meta: {
                  hidden: true,
                  key: 'system',
                },
              },
              {
                path: 'admin-istrators',
                component: () => import("@/views/admin/system/admin-istrators/index.vue"),
                name: '管理员',
                meta: {
                  hidden: true,
                  key: 'system',
                },
              },
              {
                path: 'osasm',
                component: () => import("@/views/admin/system/osasm/index.vue"),
                name: '权限组',
                meta: {
                  hidden: true,
                  key: 'system',
                },
              },
              {
                path: 'logs',
                component: () => import("@/views/admin/system/logs/index.vue"),
                name: '操作日志',
                meta: {
                  hidden: true,
                  key: 'system',
                },
              },
              {
                path: 'msg-settings',
                component: () => import("@/views/admin/system/msg-settings/index.vue"),
                name: '消息设置',
                meta: {
                  hidden: true,
                  key: 'system',
                },
              },
              {
                path: 'entry-settings',
                component: () => import("@/views/admin/system/entry-settings/index.vue"),
                name: '入驻设置',
                meta: {
                  hidden: true,
                  key: 'system',
                },
              },
              {
                path: 'area-manage',
                component: () => import("@/views/admin/system/area-manage/index.vue"),
                name: '区域管理',
                meta: {
                  hidden: true,
                  key: 'system',
                },
              },
              {
                path: 'third-party',
                component: () => import("@/views/admin/system/third-party/index.vue"),
                name: '第三方插件',
                meta: {
                  hidden: true,
                  key: 8010,
                },
              },
              {
                path: 'third-party-rate',
                component: () => import("@/views/admin/system/third-party-rate/index.vue"),
                name: '分账比率设置',
                meta: {
                  hidden: true,
                  key: 8011,
                },
              },
              // {
              //   path: 'customer-service',
              //   component: () => import("@/views/admin/system/customer-service/index.vue"),
              //   name: '客服设置',
              //   meta: {
              //     hidden: true,
              //     key: 'system',
              //   },
              // },
        ]
    },

]
